<template>
  <div>
    <h3 class="form-title">💵 新增收入</h3>
    <form @submit.prevent="incomeaddevent" class="styled-form">
      <div class="form-group">
        <label>收入來源</label>
        <select v-model="target" required>
          <option v-for="x in source" :key="x" :value="x">{{ x }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>入帳帳戶</label>
        <select v-model="acc" required>
          <option v-for="x in account" :key="x" :value="x">{{ x }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>金額</label>
        <div class="input-prefix">
          <span class="prefix">$</span>
          <input type="number" v-model="amount" placeholder="0" required />
        </div>
      </div>
      <div class="form-group">
        <label>備註</label>
        <textarea v-model="btext" placeholder="輸入備註（可選）" rows="2"></textarea>
      </div>
      <button type="submit" class="btn-submit btn-green" :disabled="adding">
        {{ adding ? '新增中...' : '💵 新增收入' }}
      </button>
    </form>
    <div v-if="success" class="toast toast-success">✅ 收入已新增！</div>
  </div>
</template>

<script>
import axios from 'axios'
axios.defaults.baseURL = 'https://mb.kman.idv.tw:9579/';

export default {
  data() {
    return {
      acc: "中國信託",
      target: "薪資",
      amount: null,
      btext: '',
      token: null,
      adding: false,
      success: false,
      account: ['中國信託', '現金', '日盛交割', '美股', '悠遊卡', '富邦保資型保單'],
      source: ['薪資', '獎金', '利息', '投資獲利', '其他']
    };
  },
  methods: {
    async incomeaddevent() {
      this.adding = true;
      try {
        await axios.post('incomeaddevent', {
          target: this.target,
          amount: this.amount,
          btext: this.btext,
          acc: this.acc,
          token: this.$store.getters.setToken,
        });
        this.target = '薪資';
        this.acc = '中國信託';
        this.btext = '';
        this.amount = null;
        this.success = true;
        setTimeout(() => { this.success = false; }, 2500);
      } catch (e) {
        alert('新增失敗');
      } finally {
        this.adding = false;
      }
    }
  }
};
</script>
<style scoped>
.form-title { font-size: 17px; font-weight: 700; margin-bottom: 20px; }
.styled-form { display: flex; flex-direction: column; gap: 14px; }
.form-group { display: flex; flex-direction: column; gap: 5px; }
.form-group label { font-size: 13px; font-weight: 600; color: var(--text-light); }
.form-group select,
.form-group input,
.form-group textarea {
  padding: 10px 12px;
  font-size: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  outline: none;
  background: #fff;
  transition: border-color 0.15s;
}
.form-group select:focus,
.form-group input:focus,
.form-group textarea:focus {
  border-color: var(--success);
  box-shadow: 0 0 0 3px rgba(5,150,105,0.1);
}
.form-group textarea { resize: none; }
.input-prefix { position: relative; }
.input-prefix .prefix {
  position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
  color: var(--success); font-size: 16px;
}
.input-prefix input { padding-left: 30px; width: 100%; }
.btn-submit {
  padding: 12px; font-size: 15px; font-weight: 600;
  color: #fff; border: none; border-radius: 8px;
  cursor: pointer; transition: all 0.15s; margin-top: 4px;
}
.btn-green { background: var(--success); }
.btn-green:hover { background: #047857; }
.btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.toast {
  margin-top: 14px; padding: 10px 16px; border-radius: 8px;
  font-size: 14px; font-weight: 500; text-align: center; animation: fadeIn 0.3s;
}
.toast-success { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
</style>
